import React, { useState, useEffect } from 'react';
import { Tag } from 'lucide-react';
import FormInput from '../FormInput';

const StatutForm = ({ 
  initialData = null, 
  onSubmit, 
  submitting = false,
  onCancel 
}) => {
  const [formData, setFormData] = useState({
    libelle: ''
  });

  const [errors, setErrors] = useState({});

  // Initialiser le formulaire avec les données existantes
  useEffect(() => {
    if (initialData) {
      setFormData({
        libelle: initialData.libelle || ''
      });
    } else {
      setFormData({
        libelle: ''
      });
    }
  }, [initialData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Clear l'erreur si l'utilisateur corrige le champ
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.libelle.trim()) {
      newErrors.libelle = "Le libellé est requis";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      onSubmit(formData);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6 max-w-xl mx-auto">
      <FormInput
        label="Libellé du statut"
        type="text"
        name="libelle"
        value={formData.libelle}
        onChange={handleInputChange}
        placeholder="Nom du statut (ex: Vacataire, Permanent, etc.)"
        required
        error={errors.libelle}
        icon={Tag}
      />

      <div className="text-sm text-gray-500">
        <span className="text-red-500">*</span> Champs obligatoires
      </div>

      <div className="flex justify-end space-x-4 pt-6">
        <button
          type="button"
          className="inline-flex justify-center px-6 py-2.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          onClick={onCancel}
        >
          Annuler
        </button>
        <button
          type="submit"
          className={`inline-flex justify-center px-6 py-2.5 text-sm font-medium text-white bg-[#202654] border border-transparent rounded-md shadow-sm hover:bg-[#161c3f] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#202654] ${submitting ? 'opacity-75 cursor-not-allowed' : ''}`}
          disabled={submitting}
        >
          {submitting ? (
            <>
              <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Traitement...
            </>
          ) : (
            initialData ? 'Mettre à jour' : 'Créer'
          )}
        </button>
      </div>
    </form>
  );
};

export default StatutForm; 